import React, { useState, useMemo, useEffect, useRef } from 'react';
import { useParams } from "react-router-dom";
import uuid from 'react-uuid';

import { ALERT_TYPE, MODE_SELECTION, REQUEST_METHOD, ShowToastMessage, memoActionSet } from '@laramie/ui';
import { APIS } from '../../config/apis';
import { ServerRequest } from '../../utils/apiweb';
import { useDispatch } from 'react-redux';
import { Loading, TableCustom, SectionHeading, InputCuenta, InputPersona, DatePickerCustom, FormLabel, FormError } from '../../components/common';
import { VALIDATION_MESSAGE } from '../../consts/validationMessage';
import ConfirmacionReciboModal from '../../components/controls/ConfirmacionReciboModal';
import { useEntidad, useForm, useFormErrors, useNav, useReporte } from '../../components/hooks'
import { getDateNow, getDateSerialize, getDateToString, getFormatNumber, precisionRound } from '../../utils/convert';
import { APPCONFIG } from '../../app.config';
import { RECIBO_TYPE } from '../../consts/reciboType';
import { CREDITOS_MODO } from '../../consts/creditosModo';
import { GetDayDifference, OpenObjectURL } from '../../utils/helpers';
import PeriodoSeleccionModal from '../../components/controls/PeriodoSeleccionModal';
import CuentaCorrienteCondicionesEspecialesGrid from '../../components/controls/CuentaCorrienteCondicionesEspecialesGrid';
import { useAccess } from '../../components/hooks/useAccess';
import DeudasMenuVertical from './components/DeudasMenuVertical';
import DeudasFiltros from './components/DeudasFiltros';
import CuentaCorrientePartidaGrid from '../../components/controls/CuentaCorrientePartidaGrid';
import { isNull } from '../../utils/validator';
import { useConfiguracion } from '../../components/hooks/useConfiguracion';
import { TIPO_ACCESORIO_CAUSIDICO_CAMPO } from '../../consts/tipoAccesorioCausidicoCampo';


function DeudaView() {

    //parametros url
    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNav()

    const entityInit = {
        cuenta: {
            id: 0,
            numeroCuenta: '',
            numeroWeb: '',
            idEstadoCuenta: 0,
            idTipoTributo: 0,
            idTributo: 0,
            fechaAlta: null,
            fechaBaja: null,
            idContribuyentePrincipal: 0,
            idDireccionPrincipal: 0,
            idDireccionEntrega: 0
        },
        contribuyente: {
            id: 0,
            idPersona: 0,
            idTipoPersona: 0,
            idTipoDocumento: 0,
            numeroDocumento: '',
            nombrePersona: '',
            fechaAlta: null
        }
    };

    //hooks
    const [state, setState] = useState({
        mode: params.mode,
        showPeriodo: false,
        showPartida: false,
        numeroPartida: 0,
        list: []
    });
    const [loading, setLoading] = useState(false);
    const [cuenta, setCuenta] = useState(entityInit.cuenta);
    const [contribuyente, setContribuyente] = useState(entityInit.contribuyente);
    const [items, setItems] = useState([]);
    const [itemsGroup, setItemsGroup] = useState([]);
    const [resumenCertificados, setResumenCertificados] = useState([]);
    const [tiposAccesorioCausidicos, setTiposAccesorioCausidicos] = useState([]);
    const [dataCondicionEspecial, setDataCondicionEspecial] = useState({
        id: 0,
        idCuenta: 0,
        numeroPartida: 0,
        codigoDelegacion: '',
        numeroMovimiento: 0,
        showForm: false,
        modeEdit: false
    });
    const [showAccesorios, setShowAccesorios] = useState(false);
    const [columnsAccesorios, setColumnsAccesorios] = useState([]);
    const [columnsCausidicos, setColumnsCausidicos] = useState([]);
    const [anchoImporteResumen, setAnchoImporteResumen] = useState(89 / 7);
    const [messageConfirm, setMessageConfirm] = useState({
        show: false,
        title: "",
        data: null,
        callback: null
    });
    const [showButtons, setShowButtons] = useState({
        PagoCuenta: false,
        PagoCuotas: false,
        PagoContado: false,
        ReciboComun: false
    });

    const [accessCuentaPagoEdit, setAccessCuentaPagoEdit] = useState(false);
    const [access, readyAceess] = useAccess({
        key: '_SecurityAccesses',
        onLoaded: (data, isSuccess, error) => {
            if (!isSuccess) {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        }
    });
    useEffect(() => {
        if (readyAceess) {
            const cuenta_pago_edit = access.some(f => f.codigo === 'cuenta-pago_edit');
            setAccessCuentaPagoEdit(cuenta_pago_edit);
        }
    }, [readyAceess]);

    const [formValues, , , formSet] = useForm({
        idCuenta: parseInt(params.id),
        fechaDeudaHasta: getDateNow(false),
        selectedAll: false
    });

    const { errorOf, validate } = useFormErrors(getErrors);

    const reciboResumidoRef = useRef(false);

    const [, getRowEntidad] = useEntidad({
        entidades: ['Tasa','SubTasa', 'TipoCondicionEspecial'],
        onLoaded: (entidades, isSuccess, error) => {
          if (isSuccess) {
            setState(prevState => ({...prevState}));
          }
          else {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
          }
        }
    });

    const [ generateReporte, ] = useReporte({
        callback: (reporte, buffer, message, filename) => {
            if (buffer) {
                OpenObjectURL(filename ?? `${reporte}.pdf`, buffer);
                ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Recibo común generado correctamente");
            }
            else {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            }
            setLoading(false);
        }
    });

    const [reciboComunDiasVencimento, ,readyReciboComunDiasVencimento ] = useConfiguracion({
        key: "ReciboComunDiasVencimento",
        onLoaded: (data, isSuccess, error) => {
            if (!isSuccess) {
              ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
          }
    });

    useEffect(() => {
        let checkAny = false;
        let checkPlanPago = false;
        const list = [...items];
        for (let index=0; index < list.length; index++) {
            if (list[index].selected) {
                checkAny = true;
                if (!isNull(list[index].idPlanPagoCuota)) {
                    checkPlanPago = true;
                }
            }
        }

        const today = getDateNow(false);
        const dayEndMonth = new Date(today.getFullYear(), today.getMonth()+1, 0);
        const yesterday = (formValues.fechaDeudaHasta && formValues.fechaDeudaHasta.getTime() < getDateNow(false).getTime());
        const changeToDay = (!formValues.fechaDeudaHasta || formValues.fechaDeudaHasta.getTime() !== today.getTime());
        const counterDays = (formValues.fechaDeudaHasta) ? GetDayDifference(today, formValues.fechaDeudaHasta) : 0;
        const counterDaysToEndMonth = (formValues.fechaDeudaHasta) ? GetDayDifference(today, dayEndMonth) : 0;

        const diasVencimento = readyReciboComunDiasVencimento ? reciboComunDiasVencimento : 0;
        const maxDay = diasVencimento > counterDaysToEndMonth ? counterDaysToEndMonth : diasVencimento;
        
        setShowButtons({
            PagoCuenta: checkAny && !yesterday && (counterDays <= maxDay) && !checkPlanPago,
            PagoCuotas: checkAny && !yesterday && (counterDays <= maxDay) && !checkPlanPago && !changeToDay,
            PagoContado: checkAny && !yesterday && (counterDays <= maxDay) && !checkPlanPago && !changeToDay,
            ReciboComun: checkAny && !yesterday && (counterDays <= maxDay)
        });

    }, [items]);

    useEffect(() => {
        //if (formValues.fechaDeudaHasta && formValues.fechaDeudaHasta.getTime() >= getDateNow(false).getTime()) {
        if (formValues.fechaDeudaHasta) {
            SearchCuentaCorrienteItem();
        }
        else {
            ClearCuentaCorrienteItem();
        }
    }, [formValues.fechaDeudaHasta]);

    useEffect(() => {
        SearchTipoAccesorio();
    }, []);


    //definiciones
    const cellVMR = (props) =>      <div className='action'>
                                        <div onClick={ (event) => handleClickPartidaView(items[props.value].numeroPartida) } className="link">
                                            <span className="material-symbols-outlined" title="ver partida">search</span>
                                        </div>
                                        {items[props.value].condicionEspecialCantidad > 0 &&
                                        <div onClick={ (event) => handleClickItemViewCondicionEspecial(props.value) } className="link">
                                            <span className="material-symbols-outlined"
                                                title={(items[props.value].condicionEspecialCantidad === 1) ? "1 condición especial" : `${items[props.value].condicionEspecialCantidad} condiciones especiales`}
                                            >warning</span>

                                        </div>
                                        }
                                    </div>

    const cellAcc = (props) =>      <div className='action'>
                                        Accesorios
                                        <div onClick={ (event) => handleClickItemToggleAccesorios() } className="link">
                                        {(showAccesorios) ?
                                            <span className="material-symbols-outlined" title="Ocultar detalle de accesorios">check_indeterminate_small</span>
                                            :
                                            <span className="material-symbols-outlined" title="Mostrar detalle de accesorios">add</span>
                                        }
                                        </div>
                                    </div>

    const cellSelAll = (props) =>   <div className='action-check'>
                                        <input name="selectedAll" type="checkbox" value={''} className='form-check-input'
                                            checked={ formValues.selectedAll }
                                            onChange={({target}) =>{
                                                const checked = target.checked;
                                                formSet({...formValues, selectedAll: checked});
                                                SelectAll(checked);
                                            }}
                                        />
                                    </div>

    const cellSel = (props) =>      <div className='action-check'>
                                        {items[props.value].selectable &&
                                        <input className='form-check-input' type="checkbox" value={''} checked={ items[props.value].selected } readOnly={true} />
                                        }
                                    </div>

    const cellSelTasa = (props) =>  <div className='action'>
                                        <div onClick={ (event) => handleClickSelectTasa(props.value) } className="link">
                                            <span className="material-symbols-outlined" title="Seleccionar">west</span>
                                        </div>
                                    </div>

    const cellSelCert = (props) =>  <div className='action'>
                                        <div onClick={ (event) => handleClickSelectCertificado(props.value) } className="link">
                                            <span className="material-symbols-outlined" title="Seleccionar">west</span>
                                        </div>
                                    </div>


    const getCodigoTasa = (id) => {
        const row = getRowEntidad('Tasa', id);
        return (row) ? row.codigo : '';
    }
    const getDescTasa = (id) => {
        const row = getRowEntidad('Tasa', id);
        return (row) ? `${row.codigo} - ${row.descripcion}` : '';
    }
    const getDescSubTasa = (id) => {
        const row = getRowEntidad('SubTasa', id);
        return (row) ? `${row.codigo} - ${row.descripcion}` : '';
    }

    const GetFooterTotal = (info, columnName) => {
        const total = useMemo(
            () =>
            info.rows.reduce((sum, row) => row.values[columnName] + sum, 0),
            [info.rows]
        )

        return <>{getFormatNumber(total,2)}</>
    }

    const tableColumnsGroups = [
        {
            Header: 'Deuda agrupada por tasa', Footer: '', disableGlobalFilter: true, disableSortBy: true,
            columns: [
                { Header: '', Cell: cellSelTasa, accessor: 'idTasa', width:'3%', disableGlobalFilter: true, disableSortBy: true},
                { Header: 'Tasa', accessor: 'descTasa', width: '47%', disableSortBy: true }
            ]
        },
        {
            Header: 'Todos', Footer: '', disableGlobalFilter: true, disableSortBy: true,
            columns: [       
                { Header: 'Importe', Footer: (info) => GetFooterTotal(info ,'importeSaldo'), Cell: (props) => getFormatNumber(props.value, 2), id: 'importeSaldo', accessor: 'importeSaldo', width: '8%', alignCell: 'right', disableSortBy: true },
                { Header: 'Accesorios', Footer: (info) => GetFooterTotal(info ,'importeAccesorios'), Cell: (props) => getFormatNumber(props.value, 2), id: 'importeAccesorios', accessor: 'importeAccesorios', width: '8%', alignCell: 'right', disableSortBy: true },
                { Header: 'Total', Footer: (info) => GetFooterTotal(info ,'importeTotal'), Cell: (props) => getFormatNumber(props.value, 2), id: 'importeTotal', accessor: 'importeTotal', width: '8%', alignCell: 'right', disableSortBy: true }
            ]
        },
        {
            Header: 'Sólo seleccionados', Footer: '', disableGlobalFilter: true, disableSortBy: true,
            columns: [
                { Header: 'Importe', Footer: (info) => GetFooterTotal(info ,'importeSaldoSel'), Cell: (props) => getFormatNumber(props.value, 2), id: 'importeSaldoSel', accessor: 'importeSaldoSel', width: '8%', alignCell: 'right', disableSortBy: true },
                { Header: 'Accesorios', Footer: (info) => GetFooterTotal(info ,'importeAccesoriosSel'), Cell: (props) => getFormatNumber(props.value, 2), id: 'importeAccesoriosSel', accessor: 'importeAccesoriosSel', width: '8%', alignCell: 'right', disableSortBy: true },
                { Header: 'Total', Footer: (info) => GetFooterTotal(info ,'importeTotalSel'), Cell: (props) => getFormatNumber(props.value, 2), id: 'importeTotalSel', accessor: 'importeTotalSel', width: '8%', alignCell: 'right', disableSortBy: true }
            ]
        }
    ];

    const tableColumnsResumenCertificados = [
        {
            Header: 'Deuda agrupada por certificado', Footer: '', disableGlobalFilter: true, disableSortBy: true,
            columns: [
                { Header: '', Cell: cellSelCert, accessor: 'idCertificadoApremio', width:'5%', disableGlobalFilter: true, disableSortBy: true},
                { Header: 'N° Certif.', accessor: 'numero', width: '6%', alignCell: 'right', disableSortBy: true },
                { Header: 'Imp. Origen', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeOrigen', width: `${anchoImporteResumen}%`, alignCell: 'right', disableSortBy: true },
                { Header: 'Recargos', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeRecargos', width: `${anchoImporteResumen}%`, alignCell: 'right', disableSortBy: true },
                { Header: 'Total s/Legales', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeTotalSinLegales', width: `${anchoImporteResumen}%`, alignCell: 'right', disableSortBy: true },
                ...columnsCausidicos,
                { Header: 'Honorarios', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeHonorarios', width: `${anchoImporteResumen}%`, alignCell: 'right', disableSortBy: true },
                { Header: 'Aportes', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeAportes', width: `${anchoImporteResumen}%`, alignCell: 'right', disableSortBy: true },
                { Header: 'Legales', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeLegales', width: `${anchoImporteResumen}%`, alignCell: 'right', disableSortBy: true },
                { Header: 'Total', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeTotalConLegales', width: `${anchoImporteResumen}%`, alignCell: 'right', disableSortBy: true }
            ]
        }
    ];

    useEffect(() => {
        const columns = (showAccesorios) ? [
            { Header: 'Multas', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeMultas', width: '5%', alignCell: 'right', disableSortBy: true, ellipsis: false},
            { Header: 'Recargos', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeRecargos', width: '5%', alignCell: 'right', disableSortBy: true, ellipsis: false},
            { Header: 'Causídicos', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeMayorC', width: '5%', alignCell: 'right', disableSortBy: true, ellipsis: false},
            { Header: 'Honorarios', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeMayorA', width: '5%', alignCell: 'right', disableSortBy: true, ellipsis: false},
            { Header: 'Aportes', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeAportes', width: '5%', alignCell: 'right', disableSortBy: true, ellipsis: false},
        ] : [];
        setColumnsAccesorios(columns);
    }, [showAccesorios])

    useEffect(() => {
        const ancho = 89 / (7 + tiposAccesorioCausidicos.length);
        // La descripción va completa: si no entra en la columna se corta con puntos suspensivos y se lee entera al pasar el mouse.
        const columns = tiposAccesorioCausidicos.map((tipo) => ({
            Header: () => <span title={tipo.descripcion}>{tipo.descripcion}</span>,
            csvHeader: tipo.descripcion,
            Cell: (props) => getFormatNumber(props.value, 2),
            accessor: TIPO_ACCESORIO_CAUSIDICO_CAMPO[tipo.id],
            width: `${ancho}%`,
            alignCell: 'right',
            disableSortBy: true
        }));
        setAnchoImporteResumen(ancho);
        setColumnsCausidicos(columns);
    }, [tiposAccesorioCausidicos])

    const tableColumns = [
        { Header: cellSelAll, Cell: cellSel, accessor: 'index', width:'3%', disableGlobalFilter: true, disableSortBy: true, ellipsis: false},
        { Header: 'Tasa', accessor: 'codigoTasa', width: '9%', disableSortBy: true, ellipsis: false},
        { Header: 'Sub tasa', accessor: 'descSubTasa', width: '26%', disableSortBy: true},
        { Header: 'Período', accessor: 'periodo', width: '6%', alignCell: 'right', disableSortBy: true, ellipsis: false},
        { Header: 'Cuota', accessor: 'cuota', width: '6%', alignCell: 'right', disableSortBy: true, ellipsis: false},
        { Header: 'Importe', Footer: (info) => GetFooterTotal(info ,'importeSaldo'), Cell: (props) => getFormatNumber(props.value, 2), id: 'importeSaldo', accessor: 'importeSaldo', width: '8%', alignCell: 'right', disableSortBy: true, ellipsis: false},
        { Header: cellAcc, Footer: (info) => GetFooterTotal(info ,'importeAccesorios'), Cell: (props) => getFormatNumber(props.value, 2), id: 'importeAccesorios', accessor: 'importeAccesorios', width: '8%', alignCell: 'right', disableSortBy: true, ellipsis: false},
        ...columnsAccesorios,
        { Header: 'Total', Footer: (info) => GetFooterTotal(info ,'importeTotal'), Cell: (props) => getFormatNumber(props.value, 2), id: 'importeTotal', accessor: 'importeTotal', width: '8%', alignCell: 'right', disableSortBy: true, ellipsis: false},
        { Header: 'Vto.', Cell: (props) => (props.value) ? getDateToString(props.value, false) : '', accessor: 'fechaVencimiento2', width: '6%', disableSortBy: true, ellipsis: false},
        { Header: 'Certif.', accessor: 'descCertificadoApremio', width: '5%', alignCell: 'right', disableSortBy: true, ellipsis: false},
        { Header: '', Cell: cellVMR, id:'abm', accessor: 'index', width: '3%', disableGlobalFilter: true, disableSortBy: true, ellipsis: false}
    ];

    //handles
    const handleClickItemToggleAccesorios = () => {
        setShowAccesorios(!showAccesorios);
    }
    const handleClickItemViewCondicionEspecial = (index) => {
        const item = items[index];
        const dataCondicionEspecial = {
            idCuenta: item.idCuenta,
            numeroPartida: item.numeroPartida,
            codigoDelegacion: item.codigoDelegacion,
            numeroMovimiento: item.numeroMovimiento,
            showForm: true,
            modeEdit: false
          };
        setDataCondicionEspecial(dataCondicionEspecial);
    }
    const handleClickPartidaView = (numeroPartida) => {
        setState(prevState => {
            return {...prevState, showPartida: true, numeroPartida: numeroPartida};
        });
    }
    const handleClickSalir = () => {
        window.close();
    }
    const handleClickSelected = (index) => {
        const list = [...items];
        if (list[index].selectable) {
            list[index].selected = !list[index].selected;
            if (list[index].idCertificadoApremio) {
                if (!handleClickCertificado(list[index].idCertificadoApremio, list[index].selected)) return;
            }
            else {
                UpdateItems(list);
            }
        }
    }

    const handleClickSelectTasa = (idTasa) => {
        const list = [...items];
        for (let index=0; index < list.length; index++) {
            if (list[index].selectable) {
                list[index].selected = (list[index].idTasa === idTasa);
            }
        }
        list.filter(f => f.selected).forEach(x => {
            if (x.idCertificadoApremio) if (!handleClickCertificado(x.idCertificadoApremio, true)) return;
            
        });
        UpdateItems(list);
    }
    const handleClickSelectCertificado = (idCertificadoApremio) => {
        const list = [...items];
        for (let index=0; index < list.length; index++) {
            if (list[index].selectable) {
                list[index].selected = (list[index].idCertificadoApremio === idCertificadoApremio);
            }
        }
        list.filter(f => f.selected).forEach(x => {
            if (x.idCertificadoApremio) if (!handleClickCertificado(x.idCertificadoApremio, true)) return;
        });
        UpdateItems(list);
    }

    const filtrosHandles = {
        handleClickInvertir: () => {
            const list = [...items];
            for (let index=0; index < list.length; index++) {
                if (list[index].selectable) {
                    list[index].selected = !list[index].selected;
                }
            }
            UpdateItems(list);
        },
        handleClickAVencer: () => {
            const toDay = formValues.fechaDeudaHasta;
            const list = [...items];
            for (let index=0; index < list.length; index++) {
                if (list[index].selectable) {
                    list[index].selected = (list[index].fechaVencimiento2.getTime() >= toDay.getTime());
                }
            }
            list.filter(f => f.selected).forEach(x => {
                if (x.idCertificadoApremio) if (!handleClickCertificado(x.idCertificadoApremio, true)) return;
            });
            UpdateItems(list);
        },
        handleClickAtrasadas: () => {
            const toDay = formValues.fechaDeudaHasta;
            const list = [...items];
            for (let index=0; index < list.length; index++) {
                if (list[index].selectable) {
                    list[index].selected = (parseInt(list[index].periodo) < toDay.getFullYear());
                }
            }
            list.filter(f => f.selected).forEach(x => {
                if (x.idCertificadoApremio) if (!handleClickCertificado(x.idCertificadoApremio, true)) return;
            });
            UpdateItems(list);
        },
        handleClickVencidas: () => {
            const toDay = formValues.fechaDeudaHasta;
            const list = [...items];
            for (let index=0; index < list.length; index++) {
                if (list[index].selectable) {
                    list[index].selected = (list[index].fechaVencimiento2.getTime() < toDay.getTime());
                }
            }
            list.filter(f => f.selected).forEach(x => {
                if (x.idCertificadoApremio) if (!handleClickCertificado(x.idCertificadoApremio, true)) return;
            });
            UpdateItems(list);
        },
        handleClickSoloJuicios: () => {
            const list = [...items];
            for (let index=0; index < list.length; index++) {
                if (list[index].selectable) {
                    list[index].selected = (list[index].idCertificadoApremio);
                }
            }
            UpdateItems(list);
        },
        handleClickPeriodo: (data) => {
            setState(prevState => {
                return {...prevState, showPeriodo: true};
            });
        },
    }

    const handleClickCertificado = (idCertificadoApremio, selected) => {
        const list = [...items];
        const certificadoClick = resumenCertificados.find(f => f.idCertificadoApremio === idCertificadoApremio);
        for (let index=0; index < list.length; index++) {
            if (list[index].idCertificadoApremio === certificadoClick.idCertificadoApremio ||
                list[index].idApremio && list[index].idApremio === certificadoClick.idApremio
            ) {
                const certificado = resumenCertificados.find(f => f.idCertificadoApremio === list[index].idCertificadoApremio);
                if (certificado) {
                    if (!certificado.pagoHabilitado) {
                        ShowToastMessage(ALERT_TYPE.ALERT_WARNING, "Hay partidas que pertenecen a apremios con certificados bloqueados");
                        SelectAll(false);
                        return false;
                    }
                }

                if (list[index].selectable) {
                    list[index].selected = selected;
                }
            }
        }
        UpdateItems(list);

        return true;
    }
    const handleClickPeriodoCallback = (data) => {
        const list = [...items];
        for (let index=0; index < list.length; index++) {
            if (list[index].selectable) {
                if (data.modeSeleccion === MODE_SELECTION.PERIODO) {
                    list[index].selected = (list[index].periodo === data.periodo);
                }
                else if (data.modeSeleccion === MODE_SELECTION.RANGO_PERIODO_CUOTA) {
                    list[index].selected = (list[index].periodoCuota >= data.periodoDesde &&
                                            list[index].periodoCuota <= data.periodoHasta);
                }
            }
        }
        list.filter(f => f.selected).forEach(x => {
            if (x.idCertificadoApremio) if (!handleClickCertificado(x.idCertificadoApremio, true)) return;
        });
        UpdateItems(list);
    }

    const handleClickVep = (esPresencial) => {
        const tipo = esPresencial ? RECIBO_TYPE.RECIBO_MOSTRADOR : RECIBO_TYPE.RECIBO_WEB;
        const data = GenerateData(tipo);
        if (data) {
            SearchCreditoReciboComun(data, esPresencial);
        }
    }
    const handleClickPagoContado = () => {
        const data = GenerateData();
        if (data) {
            const processKey = uuid();
            dispatch(memoActionSet(processKey, data, 0));
            navigate({ to: `../pago-contado/${processKey}`, replace: true, });
        }
    }
    const handleClickPagoCuotas = () => {
        const data = GenerateData();
        if (data) {
            const processKey = uuid();
            dispatch(memoActionSet(processKey, data, 0));
            navigate({ to: `../plan-pago/${processKey}`, replace: true });
        }
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
          const message = error.message;
          ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
          setLoading(false);
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setLoading(false);
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setLoading(false);
    }
    const callbackSuccessFindContribuyente = (response) => {
        response.json()
        .then((contribuyente) => {
            setContribuyente(contribuyente);
            setLoading(false);
            SearchCuentaCorrienteItem();
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setLoading(false);
        });
    }
    const callbackSuccessSearchCuentaCorrienteItem = (response) => {
        response.json()
        .then((data) => {
            let items = data.cuentaCorrienteItems;
            let itemsCertificados = [];

            for (const item of items) {
                if (item.fechaMovimiento) item.fechaMovimiento = new Date(item.fechaMovimiento);
                if (item.fechaVencimiento1) item.fechaVencimiento1 = new Date(item.fechaVencimiento1);
                if (item.fechaVencimiento2) item.fechaVencimiento2 = new Date(item.fechaVencimiento2);

                item.periodoCuota = item.periodo + item.cuota.toString().padStart(2,'0');                   
                item.codigoTasa = getCodigoTasa(item.idTasa);
                item.descTasa = getDescTasa(item.idTasa);
                item.descSubTasa = getDescSubTasa(item.idSubTasa);

                if (item.idCertificadoApremio) {
                    const certificadoApremio = data.certificadosApremio.find(f => f.id === item.idCertificadoApremio);
                    if (certificadoApremio) {
                        item.idApremio = certificadoApremio.idApremio;
                        item.descCertificadoApremio = certificadoApremio.numero;
                        let itemCertificado = itemsCertificados.find(f => f.idCertificadoApremio === item.idCertificadoApremio);
                        if (!itemCertificado) {
                            itemCertificado = {
                                idCertificadoApremio: certificadoApremio.id,
                                idApremio: certificadoApremio.idApremio,
                                numero: certificadoApremio.numero,
                                pagoHabilitado: certificadoApremio.pagoHabilitado,
                                importeOrigen: 0,
                                importeRecargos: 0,
                                importeTotalSinLegales: 0,
                                importeHonorarios: 0,
                                importeAportes: 0,
                                importeLegales: 0,
                                importeTotalConLegales: 0
                            };
                            Object.values(TIPO_ACCESORIO_CAUSIDICO_CAMPO).forEach(campo => {
                                itemCertificado[campo] = 0;
                            });
                            itemsCertificados.push(itemCertificado);
                        }
                        itemCertificado.importeOrigen += item.importeSaldo;
                        itemCertificado.importeRecargos += item.importeRecargos;
                        itemCertificado.importeTotalSinLegales += (item.importeTotal - item.importeMayorC - item.importeMayorA - item.importeAportes);
                        Object.values(TIPO_ACCESORIO_CAUSIDICO_CAMPO).forEach(campo => {
                            itemCertificado[campo] += item[campo];
                        });
                        itemCertificado.importeHonorarios += item.importeMayorA;
                        itemCertificado.importeAportes += item.importeAportes;
                        itemCertificado.importeLegales += (item.importeMayorC + item.importeMayorA + item.importeAportes);
                        itemCertificado.importeTotalConLegales += item.importeTotal;
                    }
                    else {
                        item.descCertificadoApremio = "desconocido";
                    }
                }
                else {
                    item.descCertificadoApremio = "";
                }

                const condicionesEspecialesXItem = data.cuentaCorrienteCondicionesEspeciales.filter(f => f.numeroPartida === item.numeroPartida);
                item.condicionEspecialCantidad = condicionesEspecialesXItem.length;
                if (item.condicionEspecialCantidad > 0) {
                    let tipoCondicionEspecialPrincipal = null;
                    for (let i=0; i < condicionesEspecialesXItem.length; i++) {
                        const condicionEspecial = condicionesEspecialesXItem[i];
                        tipoCondicionEspecialPrincipal = getRowEntidad('TipoCondicionEspecial', condicionEspecial.idTipoCondicionEspecial);
                        if (tipoCondicionEspecialPrincipal && tipoCondicionEspecialPrincipal.inhibicion) {
                            break;
                        }
                    }
                    item.condicionEspecialDescripcion = tipoCondicionEspecialPrincipal.nombre;
                    item.condicionEspecialInhibicion = tipoCondicionEspecialPrincipal.inhibicion;
                }
                else {
                    item.condicionEspecialDescripcion = "";
                    item.condicionEspecialInhibicion = false;
                }

            }

            for (const x of itemsCertificados) {
                x.importeOrigen = precisionRound(x.importeOrigen);
                x.importeRecargos = precisionRound(x.importeRecargos);
                x.importeTotalSinLegales = precisionRound(x.importeTotalSinLegales);
                Object.values(TIPO_ACCESORIO_CAUSIDICO_CAMPO).forEach(campo => {
                    x[campo] = precisionRound(x[campo]);
                });
                x.importeHonorarios = precisionRound(x.importeHonorarios);
                x.importeAportes = precisionRound(x.importeAportes);
                x.importeLegales = precisionRound(x.importeLegales);
                x.importeTotalConLegales = precisionRound(x.importeTotalConLegales);
            }

            setResumenCertificados(itemsCertificados);
            setState(prevState => {
                return {...prevState, list: items};
            });
            setLoading(false);

            FilterItems(items, itemsCertificados, formValues.fechaDeudaHasta);
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setLoading(false);
        });
    }
    const callbackSuccessSearchTipoAccesorio = (response) => {
        response.json()
        .then((data) => {
            const tipos = data
                .filter(f => f.agrupador === 'MAYOR_C' && f.activo === true)
                .sort((a,b) => a.orden - b.orden);
            setTiposAccesorioCausidicos(tipos);
        })
        .catch((error) => {
            setTiposAccesorioCausidicos([]);
        });
    }
    const callbackNoSuccessSearchTipoAccesorio = (response) => {
        setTiposAccesorioCausidicos([]);
    }
    const callbackErrorSearchTipoAccesorio = (error) => {
        setTiposAccesorioCausidicos([]);
    }
    const callbackSuccessAddReciboComun = (response) => {
        response.json()
        .then((data) => {
            formSet({...formValues, selectedAll: false});
            SelectAll(false);
            if (data.idCuentaPago) {
                PrintRecibo(data.idCuentaPago);
            }
            else {
                ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, `El crédito a favor (${getFormatNumber(data.importeCreditosAplicados, 2)}) cubrió la totalidad de la deuda seleccionada. No se generó VEP`);
                SearchCuentaCorrienteItem();
            }
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setLoading(false);
        });
    }
    const callbackSuccessSearchCreditoReciboComun = (response, esPresencial) => {
        response.json()
        .then((creditoReciboComun) => {
            const showCreditos = creditoReciboComun.importeCreditos > 0;
            const labelCreditos = creditoReciboComun.cubreTodo
                ? `Aplicar créditos por $ ${getFormatNumber(creditoReciboComun.importeCreditos, 2)} (cubren la totalidad de la deuda, no se generará VEP)`
                : `Aplicar créditos por $ ${getFormatNumber(creditoReciboComun.importeCreditos, 2)} (importe a pagar $ ${getFormatNumber(creditoReciboComun.importeAPagar, 2)})`;

            setLoading(false);
            setMessageConfirm({
                show: true,
                title: "Confirmación",
                data: { esPresencial, showCreditos, labelCreditos },
                callback: null
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setLoading(false);
        });
    }

    //funciones
    function getErrors() {

        const errors = {};

        if (!formValues.fechaDeudaHasta) errors.fechaDeudaHasta = VALIDATION_MESSAGE.REQUIRED_DATE;
        else if (formValues.fechaDeudaHasta.getTime() < getDateNow(false).getTime()) errors.fechaDeudaHasta = 'No puede ser anterior a hoy';

        return errors;
    }

    function GenerateData(idTipoRecibo) {
        const itemsSelected = items.filter(f => f.selected);
        if (itemsSelected.length === 0) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, "Debe seleccionar al menos un item primero");
            return null;
        }
        if (!validate()) return null;

        let data = {
            idCuenta: cuenta.id,
            fechaVencimiento: formValues.fechaDeudaHasta,
            idTipoRecibo: idTipoRecibo,
            items: []
        };
        itemsSelected.forEach(item =>  {
            const row = {
                numeroPartida: item.numeroPartida,
                idTasa: item.idTasa,
                idSubTasa: item.idSubTasa,
                codigoDelegacion: item.codigoDelegacion,
                numeroMovimiento: item.numeroMovimiento,
                periodo: item.periodo,
                cuota: item.cuota
            };
            data.items.push(row);
        });

        return data;
    }
    function PrintRecibo(idCuentaPago) {
        const paramsReporte = {
            idCuentaPago: idCuentaPago,
            reciboResumido: reciboResumidoRef.current
        }
        generateReporte("CuentaCorrienteRecibo", paramsReporte);
    }
    function FindContribuyente(idContribuyente) {
        
        setLoading(true);

        const paramsUrl = `/${idContribuyente}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CONTRIBUYENTE,
            paramsUrl,
            null,
            callbackSuccessFindContribuyente,
            callbackNoSuccess,
            callbackError
        );

    }
    function SearchCuentaCorrienteItem() {

        setLoading(true);

        const paramsUrl = `/deuda/${formValues.idCuenta}/vencimiento/${encodeURIComponent(getDateSerialize(formValues.fechaDeudaHasta))}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CUENTA_CORRIENTE_ITEM,
            paramsUrl,
            null,
            callbackSuccessSearchCuentaCorrienteItem,
            callbackNoSuccess,
            callbackError
        );

    }
    function SearchTipoAccesorio() {

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.TIPO_ACCESORIO,
            null,
            null,
            callbackSuccessSearchTipoAccesorio,
            callbackNoSuccessSearchTipoAccesorio,
            callbackErrorSearchTipoAccesorio
        );

    }
    function AddReciboComun(data) {

        setLoading(true);

        const paramsUrl = `/recibo-comun`;
        const dataBody = data;

        ServerRequest(
            REQUEST_METHOD.POST,
            null,
            true,
            APIS.URLS.CUENTA_CORRIENTE_ITEM,
            paramsUrl,
            dataBody,
            callbackSuccessAddReciboComun,
            callbackNoSuccess,
            callbackError
        );

    }
    function SearchCreditoReciboComun(data, esPresencial) {

        setLoading(true);

        const paramsUrl = `/credito-recibo-comun`;
        const dataBody = { ...data, modoCreditos: CREDITOS_MODO.TODOS };

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.CUENTA_CORRIENTE_ITEM,
            paramsUrl,
            dataBody,
            (response) => callbackSuccessSearchCreditoReciboComun(response, esPresencial),
            callbackNoSuccess,
            callbackError
        );

    }
    function ClearCuentaCorrienteItem() {
        let items = [];
        let itemsCertificados = [];

        setResumenCertificados(itemsCertificados);

        setState(prevState => {
            return {...prevState, list: items};
        });
        setLoading(false);
        FilterItems(items, [], formValues.fechaDeudaHasta);
    }

    function SelectAll(checked) {
        const list = [...items];
        for (let index=0; index < list.length; index++) {
            if (list[index].selectable) {
                list[index].selected = checked;
            }
        }
        setItems(list);
        LoadItemsGroup(list);
    }
    function UnSelectAll() {
        formSet({...formValues, selectedAll: false});
    }
    function ChangeCuenta(idCuenta) {
        const url = APPCONFIG.SITE.WEBAPP + 'deuda/' + state.mode + '/' + idCuenta;
        window.open(url, '_self');
    }
    function LoadCuenta(cuentaSelected) {
        if (cuentaSelected) {
            setCuenta(cuentaSelected);
            FindContribuyente(cuentaSelected.idContribuyentePrincipal);
        }
        else {
            setCuenta(entityInit.cuenta);
            setContribuyente(entityInit.contribuyente);
        }
    }

    function FilterItems(fullItems, certificados, fechaDeudaHasta) {
        let itemsFilter = [...fullItems].filter(f => {
            return (fechaDeudaHasta && f.fechaMovimiento.getTime() <= fechaDeudaHasta.getTime());
        });

        itemsFilter.sort((a,b) => b.indexMovimiento - a.indexMovimiento);
        itemsFilter.forEach((item, index) => {
            item.index = index;
            item.selected = false;
            item.selectable = (!item.condicionEspecialInhibicion);
            if (item.selectable && item.idCertificadoApremio) {
                const certificado = certificados.find(f => f.idCertificadoApremio === item.idCertificadoApremio);
                item.selectable = (certificado && certificado.pagoHabilitado);
            }
        });

        setItems(itemsFilter);
        LoadItemsGroup(itemsFilter);
    }
    function LoadItemsGroup(items) {
        let importeSaldo = 0;
        let importeAccesorios = 0;
        let importeSaldoSel = 0;
        let importeAccesoriosSel = 0;
        let itemsGroup = [];
        
        const itemsXTasa = [...items];
        itemsXTasa.sort((a,b) => a.idTasa - b.idTasa);
        for (let index = 0; index < itemsXTasa.length; index++) {
            const item = itemsXTasa[index];
            importeSaldo += item.importeSaldo;
            importeAccesorios += item.importeAccesorios;
            if (item.selected) {
                importeSaldoSel += item.importeSaldo;
                importeAccesoriosSel += item.importeAccesorios;
            }

            if (index === itemsXTasa.length - 1 || item.idTasa !== itemsXTasa[index+1].idTasa) {
                const itemGroup = {
                    idTasa: item.idTasa,
                    descTasa: item.descTasa,
                    importeSaldo: importeSaldo,
                    importeAccesorios: importeAccesorios,
                    importeTotal: (importeSaldo + importeAccesorios),
                    importeSaldoSel: importeSaldoSel,
                    importeAccesoriosSel: importeAccesoriosSel,
                    importeTotalSel: (importeSaldoSel + importeAccesoriosSel)
                };
                itemsGroup.push(itemGroup);

                importeSaldo = 0;
                importeAccesorios = 0;
                importeSaldoSel = 0;
                importeAccesoriosSel = 0;
            }
        }

        setItemsGroup(itemsGroup);
    }
    function UpdateItems(list) {
        UnSelectAll();
        setItems(list);
        LoadItemsGroup(list);
    }

    function GetDataPeriodo() {
        const toDay = getDateNow(false);
        const periodoDesde = Math.min(...items.map(x => parseInt(x.periodo))).toString();
        const periodoHasta = toDay.getFullYear().toString();

        return {
            periodo: periodoHasta,
            periodoDesde: periodoDesde,
            periodoHasta: periodoHasta
        }
    }

    return (
    <>

        <Loading visible={loading}></Loading>

        {messageConfirm.show &&
            <ConfirmacionReciboModal
                title={messageConfirm.title}
                message={`Vas a generar un VEP ${messageConfirm.data?.esPresencial ? 'presencial' : 'online'} para la deuda que seleccionaste. ¿Querés continuar?`}
                confirmLabel="Generar VEP"
                showCreditos={messageConfirm.data?.showCreditos}
                labelCreditos={messageConfirm.data?.labelCreditos}
                onDismiss={() => {
                    setMessageConfirm({ show: false, title: "", data: null, callback: null });
                }}
                onConfirm={({ reciboResumido, usarCreditos }) => {
                    const esPresencial = messageConfirm.data?.esPresencial;
                    const modoCreditos = usarCreditos ? CREDITOS_MODO.TODOS : CREDITOS_MODO.NINGUNO;
                    const tipo = esPresencial ? RECIBO_TYPE.RECIBO_MOSTRADOR : RECIBO_TYPE.RECIBO_WEB;
                    const data = GenerateData(tipo);
                    if (data) {
                        reciboResumidoRef.current = reciboResumido;
                        AddReciboComun({ ...data, reciboResumido, modoCreditos });
                    }
                    setMessageConfirm({ show: false, title: "", data: null, callback: null });
                }}
            />
        }

        {state.showPeriodo && 
            <PeriodoSeleccionModal
                data={GetDataPeriodo()}
                onConfirm={(data) => {
                    handleClickPeriodoCallback(data);
                    setState(prevState => {
                        return {...prevState, showPeriodo: false};
                    });
                }}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showPeriodo: false};
                    });
                }}
            />
        }

        {state.showPartida && 
            <CuentaCorrientePartidaGrid
                data={{
                    idCuenta: formValues.idCuenta,
                    idTipoTributo: cuenta.idTipoTributo,
                    numeroPartida: state.numeroPartida
                }}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showPartida: false, numeroPartida: 0};
                    });
                }}
            />
        }

        {dataCondicionEspecial.showForm && 
            <CuentaCorrienteCondicionesEspecialesGrid
                data={{
                    idCuenta: dataCondicionEspecial.idCuenta,
                    idTipoTributo: cuenta.idTipoTributo,
                    numeroPartida: dataCondicionEspecial.numeroPartida,
                    codigoDelegacion: dataCondicionEspecial.codigoDelegacion,
                    numeroMovimiento: dataCondicionEspecial.numeroMovimiento
                }}
                onDismiss={() => {
                    setDataCondicionEspecial(prevState => { return {...prevState, showForm: false}; });
                }}
                disabled={!dataCondicionEspecial.modeEdit}
                onlyActived={true}
            />
        }
        <section style={{height:'20px'}}></section>
        <SectionHeading titles={[{ title: 'Tributos' }, { title: 'Cálculo de deuda' }]} />

        <section className='section-accordion'>

            <div className='row form-basic mb-3'>
                <div className="col-12 col-md-6 col-lg-2">
                    <label htmlFor="cuenta" className="form-label">Cuenta</label>
                    <InputCuenta
                        name="cuenta"
                        placeholder=""
                        className="form-control"
                        value={formValues.idCuenta}
                        onUpdate={({target}) => {
                            LoadCuenta(target.row);
                        }}
                        onChange={({target}) => {
                            if (target.row) {
                                ChangeCuenta(target.value);
                            }
                        }}
                    />
                    <FormError />
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                    <label htmlFor="contribuyente" className="form-label">Contribuyente</label>
                    <InputPersona
                        name="contribuyente"
                        placeholder=""
                        className="form-control"
                        value={contribuyente.idPersona}
                        disabled={true}
                    />
                    <FormError />
                </div>
                <div className="col-6 col-md-6 col-lg-2">
                    <FormLabel htmlFor="fechaDeudaHasta" required>Deuda al</FormLabel>
                    <DatePickerCustom
                        name="fechaDeudaHasta"
                        placeholder=""
                        className={`form-control ${errorOf('fechaDeudaHasta') ? 'is-invalid' : ''}`}
                        value={formValues.fechaDeudaHasta}
                        onChange={({target}) =>{
                            const fechaDeudaHasta = target.value;
                            formSet({...formValues, fechaDeudaHasta: fechaDeudaHasta});
                        }}
                    />
                    <FormError message={errorOf('fechaDeudaHasta')} />
                </div>
            </div>

            <div className="m-top-20">

                <TableCustom
                    showFooter={true}
                    showFilterGlobal={false}
                    className={'TableCustomBase'}
                    columns={tableColumnsGroups}
                    data={itemsGroup}
                />

            </div>

            {resumenCertificados.length > 0 &&
            <div className="m-top-20">

                <div className="col-12">
                    <TableCustom
                        showFooter={true}
                        showFilterGlobal={false}
                        className={'TableCustomBase'}
                        columns={tableColumnsResumenCertificados}
                        data={resumenCertificados}
                    />
                </div>

            </div>
            }

            {formValues.fechaDeudaHasta && <DeudasFiltros {...filtrosHandles} />}

            <div className="m-top-20">

                <TableCustom
                    showFooter={true}
                    showFilterGlobal={false}
                    className={'TableCustomBase'}
                    columns={tableColumns}
                    data={items}
                    onClickRow={(row, cellId) => {
                        if (cellId !== "abm") {
                            handleClickSelected(row.index);
                        }
                    }}
                />

            </div>


        </section>

        <footer className='footer footer-action'>
            <div className='footer-action-container'>
                <button className="btn back-button float-start" onClick={ (event) => handleClickSalir() }>Volver</button>
                {accessCuentaPagoEdit && <DeudasMenuVertical {...{ showButtons, handleClickPagoCuotas, handleClickPagoContado, handleClickVep }} />}
            </div>
        </footer>
        
    </>
    )
}

export default DeudaView;
